export const standardTransition = (
  propertyName,
  duration = '0.2s',
  easingFunction = 'linear'
) => {
  return `${propertyName} ${duration} ${easingFunction}`;
};
